import { create } from "zustand";
import { combine } from "zustand/middleware";
import { getSceneRecipeUiMetadataById } from "../utils/sceneRecipes.js";

export type SceneBehaviorRecipeSnapshot = {
  recipeId: string | null;
  scenarioId: string | null;
  recipeRobotId: string | null;
};

const emptySnapshot: SceneBehaviorRecipeSnapshot = {
  recipeId: null,
  scenarioId: null,
  recipeRobotId: null,
};

export const useSceneBehaviorContextStore = create(
  combine({ ...emptySnapshot }, (set) => ({
    actions: {
      setFromPresetRecipeId(recipeId: string) {
        const trimmed = String(recipeId || "").trim();
        if (!trimmed) {
          set(emptySnapshot);
          return;
        }
        const meta = getSceneRecipeUiMetadataById(trimmed);
        set({
          recipeId: trimmed,
          scenarioId: meta?.scenarioId ? String(meta.scenarioId) : null,
          recipeRobotId: meta?.robotId ? String(meta.robotId) : null,
        });
      },
      clear() {
        set(emptySnapshot);
      },
    },
  }))
);

export const getSceneBehaviorContextStoreActions = () =>
  useSceneBehaviorContextStore.getState().actions;
